import { ProgressSpinner } from '@dittolive/anvil'
import React from 'react'

/**
 * This is used to show a full page loader
 */
export const FullPageLoader: React.FC = () => {
  return (
    <div className="flex h-screen items-center justify-center py-12">
      <ProgressSpinner className="size-6" />
    </div>
  )
}

export default FullPageLoader
